import { motion } from 'motion/react'
import React from 'react'
import { CloseIcon } from '../svgs/ExpressonSVGs'

const MotionDiv = motion.div

export type MessageBannerProps = {
  children: React.ReactNode
  className?: string
  customMotionProps?: React.ComponentPropsWithoutRef<typeof MotionDiv>
  hasCloseButton?: boolean
  onCloseBanner?: () => void
}

export type BannerData = {
  id: string
  content: React.ReactNode
  bannerProps?: Omit<MessageBannerProps, 'children'>
}

export const MessageBanner: React.FC<MessageBannerProps> = ({
  children,
  className = '',
  customMotionProps = {},
  hasCloseButton = false,
  onCloseBanner
}) => {

  return (
    <MotionDiv
      initial={{ position: 'relative', top: '-6rem', height: 'auto', opacity: 0 }}
      animate={{ height: 'auto', top: '0', opacity: 1 }}
      transition={{ duration: 1.5, ease: "easeInOut", delay: 0.8 }}
      //layout - not needed here but kept for future use
      className={[
        'message-banner',
        className
      ].join(' ')}
      {...customMotionProps}
    >
      <div>
        {children}
        {hasCloseButton && (
          <button
            className="message-banner__close-button"
            aria-label="Stäng meddelande"
            onClick={(e) => {
              e.preventDefault();
              onCloseBanner?.();
            }}
          >
            <CloseIcon width={24} height={24} />
          </button>
        )}
      </div>
    </MotionDiv>
  )
}

export default MessageBanner
